/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
  PdfExport,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';

import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Header from './Header';
import { ssteventsCPGrid } from '../data/dummy';
import '../pages/Zackat.css';

function SSTEvents({ props }) {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    zRenderMode,
    sstLimitPreference,
    setSSTLimitPreference,
    boss,
  } = useStateContext();
  const [pauseEnable, setPause] = useState(false);
  const [reload, setReload] = useState(false);
  const grid = useRef(null);
  const panelRef = useRef(null);
  const pause = { text: 'Pause', tooltipText: 'Pause Refresh', prefixIcon: 'e-pause', id: 'pause', disabled: pauseEnable };
  const resume = { text: 'Resume', tooltipText: 'Resume Refresh', prefixIcon: 'e-repeat', id: 'resume', disabled: !pauseEnable };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const del = { text: 'Delete', tooltipText: 'Delete STT Event', prefixIcon: 'e-delete-2', id: 'delete' };

  let toolbarOptions = [del, pause, resume, 'Search'];
  const [searchParams] = useSearchParams();
  let associateid = searchParams.get('id');
  let assocId = searchParams.get('name');
  let associatename = 'STT Events for ';
  let device = searchParams.get('device');
  let myfont = '';
  let source = 'zackat-div';
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [sstEventLimit, setSSTEventLimit] = useState(localStorage.getItem('sstEventLimit') || 14);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [fromHere, setFromHere] = useState(new Date());
  const [toHere, setToHere] = useState(new Date());
  const calculateDays = (f, t) => {
    if (!f || !t) return null;

    const start = new Date(f);
    const end = new Date(t);

    // Get time difference in milliseconds
    const timeDiff = end.getTime() - start.getTime();

    // Convert milliseconds to days and round the value
    const dayInMs = 24 * 60 * 60 * 1000;
    const daysDiff = Math.ceil(timeDiff / dayInMs);

    return daysDiff;
  };

  const fromTemplate = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      <DateTimePickerComponent
        id="fromdate"
        onChange={(e) => {
          setFrom((e.value.getTime() / 1000).toFixed(0));
          setFromHere(e.value);
        }}
        placeholder="Select From Date/Time"
        defaultValue={fromHere}
      />
    </div>
  );
  const toTemplate = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      <DateTimePickerComponent
        id="todate"
        onChange={(e) => {
          setTo((e.value.getTime() / 1000).toFixed(0));
          setToHere(e.value);
          const days = calculateDays(fromHere, e.value);
          if ((days !== null && days > 0) || e.value !== toHere) {
            setReload(days);
          }
        }}
        placeholder="Select To Date/Time"
        defaultValue={toHere}
      />
    </div>
  );
  const setLimits = () => {
    const lim = document.getElementById('limit').value;
    setData([]);
    setSSTEventLimit(lim);
    setFrom(0);
    setTo(0);
    setFromHere(new Date());
    setToHere(new Date());
    localStorage.setItem('sstEventLimit', Number(lim));
    setSSTLimitPreference(!sstLimitPreference);
  };
  const limitTemplate = () => (
    <div className="e-toolbar-left">
      <input type="text" id="limit" placeholder="Limit number of days" defaultValue={sstEventLimit} className="custom-toolbar-input" />
      <button type="button" className="e-btn e-success e-outline" onClick={() => { setLimits(); }}>Limit Days</button>
    </div>
  );

  if (props && props._id && props._id.length > 0 && props.name && props.name.length > 0) {
    associateid = props._id;
    assocId = props.name;
    device = props.device;
    associatename += props.name;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (props && props._id && props._id.length > 0 && props.device.length > 0) {
    associateid = ''; // props.associateid;
    assocId = props.device;
    device = props.device;
    associatename += props.device;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (associateid) {
    associatename += `${assocId}`;
  } else {
    associatename += `${device}`;
    associateid = null;
  }
  if (source === 'controlpanel') {
    toolbarOptions = ['Search', del, pause, resume, excel];
  }

  const editing = { allowDeleting: false, allowEditing: false };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const timerid = useRef();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (device !== null) {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        let url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&associateid=${associateid}&device=${device}&limit=${sstEventLimit}`;
        if (!associateid || associateid.length === 0) {
          url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&device=${device}&limit=${sstEventLimit}`;
        }
        if (from !== 0 && to !== 0) {
          url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&device=${device}&from=${from}&to=${to}`;
        }
        await axios({
          url,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data) {
              setData(response.data);
            }
            setLoading(false);
          })
          .catch((error) => {
            console.error(error.message);
            setLoading(false);
          });
      } else {
        await axios({
          url: `${REACT_APP_API_ENDPOINT}/sst_events?associateid=${associateid}&limit=${sstEventLimit}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setData(response.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error.message);
            setLoading(false);
          });
      }
    };
    fetchData();
  }, [associateid, sstEventLimit, reload]);

  useEffect(() => {
    const trapEnter = (e) => {
      if (e.key !== 'Enter' && e.keyCode !== 13) {
        return;
      }
      const root = panelRef.current;
      const { target } = e;
      if (!root || !target || !root.contains(target)) {
        return;
      }
      const tag = target.tagName;
      if (tag !== 'INPUT' && tag !== 'TEXTAREA') {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
    };
    document.addEventListener('keydown', trapEnter, true);
    return () => document.removeEventListener('keydown', trapEnter, true);
  }, []);
  /*
  async function fetchEvents() {
    const loc = window.location;
    if (loc.pathname !== '/sst_events' && !loc.pathname.includes('associate') && !loc.pathname.includes('/inventory') && !loc.pathname.includes('/basic')) {
      setPause(!pauseEnable);
      if (timerid.current) {
        timerid.current = clearInterval(timerid.current);
        return;
      }
    }
    if (device != null) {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');

      let url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&associateid=${associateid}&device=${device}&limit=${sstEventLimit}`;
      if (!associateid || associateid.length === 0) {
        url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&device=${device}&limit=${sstEventLimit}`;
      }
      if (from !== 0 && to !== 0) {
        url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&device=${device}&from=${from}&to=${to}`;
      }

      await axios({
        url,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setData(response.data);
      })
        .catch((e) => {
          console.error(e);
        });
    } else {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/sst_events?associateid=${associateid}&limit=${sstEventLimit}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setData(response.data);
      })
        .catch((e) => {
          console.error(e);
        });
    }
  }
*/
  useEffect(() => {
    if (!pauseEnable) {
      timerid.current = setInterval(setReload(!reload), 30000);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, [props, pauseEnable]);

  const [isPlaying, setIsPlaying] = useState(false);

  const startPCM = async (e, duration) => {
    if (isPlaying) {
      return;
    }
    setIsPlaying(true);
    try {
      const audio = new Audio(`${REACT_APP_API_ENDPOINT}/sttdown?photo=${e}`);
      await audio.play();
      setTimeout(() => { setIsPlaying(false); }, duration || 2000);
    } catch (error) {
      console.error('play pcm error', error);
      setIsPlaying(false);
      DialogUtility.alert('Error downloading audio, please try again later!');
    }
  };
  const recordPlayTemplate = (dprops) => (
    <div>
      {/* <input type="button" name="download" id={dprops.filename} value="&#x23F5;"  onClick={startPCM} /> */}
      <ButtonComponent cssClass="e-large" iconCss="e-icons e-play" style={{ float: 'left' }} id={dprops._id} onClick={() => { startPCM(dprops._id, dprops.length / 16); }}>Play</ButtonComponent>
    </div>
  );

  const flattenObject = (obj, prefix = '') => Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}.` : '';
    if (
      typeof obj[k] === 'object'
      && obj[k] !== null
      && Object.keys(obj[k]).length > 0
    ) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});

  const clickHandler = (args) => {
    if (args.item.properties.text === 'Pause') {
      setPause(!pauseEnable);
    } else if (args.item.properties.text === 'Resume') {
      setPause(!pauseEnable);
    } else if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_${associatename}_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(flattenObject(properties));
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_${associatename}_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(flattenObject(properties));
    } else if (grid && grid.current && args.item.properties.text === 'Delete') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Events handler: Please select an Event!');
      } else if (selectedRecords[0]) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/sst_events`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(selectedRecords[0]),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            DialogUtility.alert('STT EVent Action DELETE, your event has been removed!');
            setReload(!reload);
          })
          .catch((error) => {
            DialogUtility.alert(`STT EVent Action DELETE, error ${error.message}!`);
          });
      }
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const wrapSettings = { wrapMode: 'Both' };
  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div
      ref={panelRef}
      className={source === 'controlpanel' ? 'm-1 md:m-1 mt-2 p-2 md:p-2 rounded-3xl' : 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh'}
    >
      <Header category="" title={associatename} />
      <div id="container">
        <ToolbarComponent id="toolbar">
          <ItemsDirective>
            <ItemDirective template={limitTemplate} disabled={false} />
            <ItemDirective type="Separator" />
            {boss && <ItemDirective template={fromTemplate} disabled={false} />}
            {boss && <ItemDirective type="Separator" />}
            {boss && <ItemDirective template={toTemplate} disabled={false} />}
            {boss && <ItemDirective type="Separator" />}
          </ItemsDirective>
        </ToolbarComponent>
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data}
              className={myfont}
              allowPaging
              width="100%"
              allowSorting
              allowExcelExport
              allowPdfExport
              editSettings={editing}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              enableHover={false}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              allowFiltering
              filterSettings={FilterOptions}
              showColumnChooser
              allowTextWrap
              textWrapSettings={wrapSettings}
              ref={grid}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {ssteventsCPGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                <ColumnDirective
                  field="_id"
                  headerText="File"
                  template={recordPlayTemplate}
                  width="100"
                  isPrimaryKey
                  visible
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize, PdfExport, ExcelExport]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SSTEvents;
